import { createClient } from '@supabase/supabase-js';

// Production defaults. Supabase anon keys are public by design — they only
// grant access subject to the project's RLS policies, so embedding them
// here is safe and makes `npm run build` work without any env files
// (e.g. on CI/CD where .env* is not checked in).
const DEFAULT_URL = 'https://sb.eulea.me';
const DEFAULT_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzM1Njg5NjAwLCJleHAiOjIwNTEyMjI0MDB9.ruNuKSnxDY7jRaL7tJn8T527rs__PqtV_hrYMzIgGdA';

const url = process.env.REACT_APP_SUPABASE_URL || DEFAULT_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || DEFAULT_ANON_KEY;

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: window.localStorage
  }
});

export const isSupabaseConfigured = Boolean(url && anonKey);
